import { useContext } from 'react';
import {
  Flex,
  Modal,
  ModalContext,
  Text,
} from 'dash-ui';

import {
  GetOrganizationsForSelectDocument,
  GetOrganizationsForTableDocument,
  GetPropertiesDocument,
  useDeleteOrganizationMutation,
} from 'gql/generated.graphql';
import { OrganizationModals } from 'pages/organizations/constants/constants';
import { useTranslation } from 'react-i18next';

const DeleteOrganizationModal = () => {
  const { toggleModal, payload, isOpenCurrent } = useContext(ModalContext);
  const { t } = useTranslation();
  const { t: tModal } = useTranslation('common', {
    keyPrefix: 'modalDelete',
  });
  const { t: tLabels } = useTranslation('common', {
    keyPrefix: 'labels',
  });

  const [removeOrganization, { loading }] = useDeleteOrganizationMutation({
    refetchQueries: [
      GetPropertiesDocument,
      GetOrganizationsForSelectDocument,
      GetOrganizationsForTableDocument,
    ],
  });

  const onSubmit = async () => {
    await removeOrganization({
      variables: {
        organizationId: payload?._id,
      },
    });
  };

  const isOpen = isOpenCurrent[OrganizationModals.DELETE_ORGANIZATION];

  async function submitModal() {
    toggleModal(false, OrganizationModals.DELETE_ORGANIZATION);
    if (payload?.propertiesCount) {
      toggleModal(true, OrganizationModals.CONFIRMATION_DELETE_ORGANIZATION);
    } else {
      await onSubmit();
    }
  }

  function closeModal() {
    toggleModal(false, OrganizationModals.DELETE_ORGANIZATION);
  }

  return (
    <Modal
      isOpen={isOpen}
      title={tModal('title', { entity: 'Organization' }) || ''}
      children={
        <Flex flexDirection="column">
          <Text>
            {tModal('confirmationText') || ''} <strong>{payload?.name}</strong> "Organization"?
          </Text>
          <Text><strong>Note:</strong>{' '}{t('pages:organizationDashboardPage:deleteOrganizationModalNote') || ''}</Text>
        </Flex>
      }
      submitButton={{
        title: tLabels`delete`,
        onClick: submitModal,
        colorVariation: 'danger',
        isLoading: loading,
      }}
      cancelButton={{
        title: tLabels`cancel`,
        onClick: closeModal,
      }}
    />
  );
};

export default DeleteOrganizationModal;
